import urlFilter from "../filters/url.filter";
import { ShowCaseActionType } from "./enums/showCaseActionType"; 

/** Класс для данных о странице витрины */

export class ShowcaseDepositData {

  /// <summary>
  /// Код вида вклада
  /// </summary>
  public DepType: string = '';

  /// <summary>
  /// Клиентское наименование вида вклада
  /// </summary>
  public Caption: string = '';

  /// <summary>
  /// Описание вида вклада
  /// </summary>
  public Description: string = '';

  /// <summary>
  /// Тип действия кнопки "Подробные условия"
  /// </summary>
  public DetailActionType: ShowCaseActionType = ShowCaseActionType.None;

  /// <summary>
  /// Ссылка действия кнопки "Подробные условия"
  /// </summary>
  public DetailActionLink: string = '';

  /// <summary>
  /// Процентная ставка
  /// </summary>
  public Persent: number = 0;

  /// <summary>
  /// Описание требований к сроку, например: "до 1 года" 
  /// </summary>
  public Period: string = '';

  /// <summary>
  /// Описание требований к сумме, например: "от 30 000 р."
  /// </summary>
  public Summa: string = '';

  /// <summary>
  /// Признак доступности частичного пополнения
  /// </summary>
  public DepositEnable: boolean = false;

  /// <summary>
  /// Признак доступности частичного снятия
  /// </summary>
  public DraftEnable: boolean = false;

  /// <summary>
  /// Вид дейтствия кнопки оформить
  /// </summary>
  public ActionType: ShowCaseActionType = ShowCaseActionType.None;

  /// <summary>
  /// Ссылка действия оформить
  /// </summary>
  public ActionLink: string = '';

  /// <summary>
  /// Действующий процент без капитализации или когда один вариант
  /// </summary>
  public IncomePerc: number = 0;

  /// <summary>
  /// Доходность на конец срока без капитализации или когда один вариант
  /// </summary>
  public IncomeSum: number = 0;

  /// <summary>
  /// Действующий процент с капитализацией
  /// </summary>
  public IncomePercCapital: number = 0;

  /// <summary>
  /// Доходность на конец срока с капитализацией
  /// </summary>
  public IncomeSumCapital: number = 0;

  /// <summary>
  /// Картинка
  /// </summary>
  public Image: string = '';

  /// <summary>
  /// Картинка для адаптива
  /// </summary>
  public ImageMp: string = '';

  /// <summary>
  /// Есть специальные условия для пенсионеров
  /// </summary>
  public PensionEnable: boolean = false;

  constructor(src: any) {
    this.DepType = src.type ?? '';
    this.Caption = src.caption ?? '';
    this.Description = src.description ?? '';
    this.DetailActionType = (src.detailActionType ?? '') as ShowCaseActionType;
    this.DetailActionLink = src.detailActionLink ?? '';
    this.Persent = src.percent ?? 0;
    this.Period = src.period ?? '';
    this.Summa = src.summa ?? '';
    this.DepositEnable = src.depositEnable === '1';
    this.DraftEnable = src.draftEnable === '1';
    this.ActionType = (src.actionType ?? '') as ShowCaseActionType;
    this.ActionLink = src.actionLink ?? '';
    this.IncomePerc = src.incomePerc ?? '0';
    this.IncomeSum = src.incomeSum ?? '0';
    this.IncomePercCapital = src.incomePercCapital ?? '0';
    this.IncomeSumCapital = src.incomeSumCapital ?? '0';
    this.Image = urlFilter(src.imageWeb ?? '');
    this.ImageMp = urlFilter(src.image ?? '');
    this.PensionEnable = src.pensionEnable === '' ? null : src.pensionEnable === '1';
  }
}